const report = {
  logistics: "Reports",
  listIssuesBreadcrumb: "Issues List",
  listReportBreadcrumb: "Report Details",
  listReport: {
    noDataFound: "Sorry, No issues found",
    noReportsFound: "No reports found",
    open: "Open",
    closed: "Closed",
    reportList: "Report List",
    reportTitle: "Report title",
    eventName: "Event Name",
    zones: "Zones",
    zone: "Zone",
    name: "Reporter name",
    role: "Reporter Position",
    supervisor: "Supervisor",
    createdDate: "Created Date",
    createdTime: "Created Time",
    dateTime: "Date & Time",
    createdDateTime: "Created Date & Time",
    closedDateTime: "Closed Date & Time",
    closedTime: "Closed Time",
    closedDate: "Closed Date",
    date: "Date",
    time: "Time",
    status: "Status",
    zoneNo: "Zone No.",
    issueDesc: "Issue Description",
    images: "Images",
  },
  modalTitle: "Export report",
  exportModalDescription: "Select the fields you want to include in your file.",
  selectAllFields: "Select all fields",
  searchPlaceholder: "Search by report title",
  filter: "Filter",
  reporterPosition: "Reporter Position",
  reportedAt: "Reported at",
  resolvedAt: "Resolved at",
  dateRangeFilter: {
    from: "From Date",
    to: "To Date",
  },
  reporterPositions: {
    supervisor: "Supervisor",
    employee: "Employee",
    yoramAdmin: "Yoram Admin",
  },
  showingRange: "Showing {from}-{to} of {total} reports",
  emptyTitle: "No reports yet",
  emptyDescription: "Add your first report to get started.",
  eventEmptyDescription:
    "Reports will appear here once submit an issue during this event.",
  noResultsTitle: "No reports found",
  noResultsDescription: "No reports match your search or filters.",
  addReport: {
    addReport: "Add Report",
    addNewReport: "Add New Report",
    title: "Add new report",
    description: "Submit a new issue or incident report for verification.",
    submit: "Submit Report",
    reportTitle: "Report Title",
    reportTitlePlaceholder: "e.g. Safety hazard at Zone A entrance",
    event: "Event",
    eventPlaceholder: "Select event",
    zone: "Affected Zone",
    zonePlaceholder: "Select location",
    issueDescription: "Description",
    issueDescriptionPlaceholder: "Type issue details here...",
    descriptionHint: "Up to 300 characters. Letters, digits, and special characters are allowed.",
    descriptionMaxLengthError: "You can't enter more than 300 characters.",
    reportStatus: "Report status",
    uploadLabel: "Upload Attachment",
    uploadClickToUpload: "Click to upload",
    uploadDragHint: "or drag and drop",
    uploadHint: "PNG or JPG only — max 10MB each, up to 4 files.",
    uploadFormatHint: "PNG or JPG only — max 10MB each.",
    uploadRemainingHint: "You can upload {count} more picture(s).",
    uploadLimitReached:
      "You've reached the maximum of 4 pictures. You can't upload more.",
    uploadMaxSizeError: "Max size is 10MB",
    uploadTypeError: "Accepted formats are jpg and png only",
    required: "This field is required",
  },
  exportSheetColumns: {
    reportList: "Report List",
    reportName: "Report Name",
    description: "Description",
    attachments: "Attachments",
    reportedDate: "Reported Date",
    reportedTime: "Reported Time",
    reporterName: "Reporter Name",
    reporterPosition: "Reporter Position",
    status: "Status",
    resolutionDate: "Resolution Date",
    resolutionTime: "Resolution Time",
    zone: "Zone",
    zoneSupervisor: "Zone Supervisor",
    comments: "Comments",
    eventName: "Event Name",
    supervisor: "Supervisor",
    export: "Export",
    exportReportToExcel: "Export Reports to Excel Sheet",
  },
  noPreview: " No preview available!",
  updates: "Comments",
  viewReport: {
    breadcrumbReport: "Reports",
    reportId: "Report ID",
    priority: "Priority",
    metadata: "Report overview",
    reportedDate: "Reported Date",
    reportedTime: "Reported Time",
    reportedAt: "Reported at",
    resolvedAt: "Resolved at",
    durationOpen: "Duration Open",
    durationHoursUnit: "h",
    durationMinutesUnit: "m",
    evidenceMedia: "Evidence & Media",
    filesAttached: "{count} Files Attached",
    reportingBy: "Reporting By",
    noComments: "No comments yet.",
    emptyCommentsTitle: "No comments added yet",
    emptyCommentsDescription:
      "Add comments and updates related to this report for your team.",
    addCommentPlaceholder: "Add a comment...",
    commentMaxLengthError: "You can't enter more than 300 characters.",
    postComment: "Post Comment",
    resolveIssue: "Resolve issue",
    viewProfile: "View Profile",
  },
  resolveReport: {
    title: "Resolve issue",
    description: "Are you sure you want to mark this issue as resolved?",
    commentLabel: "Resolution Description",
    commentPlaceholder: "Describe how the issue was resolved...",
    confirm: "Resolve",
    uploadClickToUpload: "Click to upload",
    uploadDragHint: "or drag and drop",
    uploadHint: "PNG or JPG only — max 10MB each, up to 4 pictures total.",
    uploadFormatHint: "PNG or JPG only — max 10MB each.",
    uploadRemainingHint: "You can upload {count} more picture(s).",
    uploadLimitReached:
      "You've reached the maximum of 4 pictures. You can't upload more.",
    uploadMaxSizeError: "Max size is 10MB",
  },
  deleteModal: {
    title: "Delete File",
    content: "Are you sure you want to delete this file?",
  },
};
export default report;
